// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"622d9017","607":"20708e4d","806":"95a51b50","850":"16112311"}[chunkId] + ".chunk.css";
};